import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestEarplugLawyersWrapper from "@components/layouts/bestearpluglawyersWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function BestEarplugLawyersHome(): ReactElement {
    return (
        <BestEarplugLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="Military Earplugs"
                    domain="BestEarplugLawyers.com"
                />
            </div>
        </BestEarplugLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
